import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

shareListModalStyles.recipientEmailAddressGridItem = {
    width: [12, 6, 6, 6, 6], 
    css: css`
    >${FormFieldStyle}{
        >${TypographyStyle}{
            margin-top: -3.5px;
        }
    }
    `
}